export const getClosestValidZoom = (
  rawZoom: number,
  minZoom: number,
  maxZoom: number
) => {
  if (rawZoom > maxZoom) return maxZoom;
  if (rawZoom < minZoom) return minZoom;
  return rawZoom;
};
